import {Updatable} from '@fantasmagames/core/src/update/Updatable';
import {IUpdatable} from '@fantasmagames/core/src/update/_interfaces/IUpdatable';

export class UpdateManager extends Updatable {
	private _updatables: IUpdatable[] = [];
	private _needToRemove: IUpdatable[] = [];

	public update(dt: number): void {
		for (const updatable of this._updatables) {
			updatable.isPlaying && updatable.update(dt);
		}

		this.cleanup();
	}

	public add(updatable: IUpdatable): void {
		this._updatables.push(updatable);
		updatable.updateManager = this;
	}

	public remove(updatable: IUpdatable): void {
		const index = this._updatables.indexOf(updatable);

		if (index !== -1) {
			this._needToRemove.push(updatable);
		}
	}

	public removeAll(): void {
		this._updatables.length = 0;
		this._needToRemove.length = 0;
	}

	protected cleanup(): void {
		for (const updatable of this._needToRemove) {
			const index = this._updatables.indexOf(updatable);

			if (index !== -1) {
				updatable.updateManager = null;
				this._updatables.splice(index, 1);
			}
		}

		this._needToRemove.length = 0;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/update/UpdateManager.ts